import { Select } from 'formik-antd'
import React, { FC } from 'react'

export const validRatings = {
  long: [
    'AAA',
    'AA+',
    'AA',
    'AA-',
    'A+',
    'A',
    'A-',
    'BBB+',
    'BBB',
    'BBB-',
    'BB+',
    'BB',
    'BB-',
    'B+',
    'B',
    'B-',
    'CCC+',
    'CCC',
    'CCC-',
    'CC',
    'C',
    'RD',
    'SD',
    'D',
    'Z',
  ],
  short: ['A-1+', 'A-1', 'A-2', 'A-3', 'B', 'C', 'D', 'Z'],
}

interface Props {
  name: string
  longRatings?: boolean
  disabled?: boolean
}

const buildOptions = (ratings: string[]) =>
  ratings.map((rating) => ({ value: rating, label: rating === 'Z' ? 'Unrated' : rating }))

export const SelectRating: FC<Props> = ({ name, longRatings, ...props }) => {
  const options = buildOptions(longRatings ? validRatings.long : validRatings.short)

  return <Select name={name} placeholder="Select a rating" options={options} {...props} />
}
